import { React } from "react";
import ReactDom from "react-dom";
import "./form.css";
import moment from "moment";
import config from "../config.json";

import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  videoLink: yup.string().required(),
  previewImage: yup.string().required(),
  title: yup.string().required(),
  genre: yup.string().required(),
  contentRating: yup.string().required(),
  releaseDate: yup.string().required(),
});

const content = {
  inputs: [
    {
      id: "1",
      label: "VideoLink",
      name: "videoLink",
      message: "Provide a embed youtube link",
    },
    {
      id: "2",
      label: "ImgLink",
      name: "previewImage",
      message: "Provide a thumbnail for video",
    },
    {
      id: "3",
      label: "Title",
      name: "title",
      message: "Provide title for video",
    },
  ],
};

function Modal({ open, onClose }) {
  const { register, handleSubmit} = useForm({
    resolver: yupResolver(schema),
  });
  const postVideoAPI = async (reqBody) => {
    let response;
    var reqObj = {
      ...reqBody,
      releaseDate: moment(reqBody.releaseDate).format("D MMM YYYY"),
    };
    response = await fetch(`${config.endpoint}/videos`, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: JSON.stringify(reqObj),
    });
    if (response.ok) {
      alert("Sucessfully Submited the Video");
    } else {
      response = await response.json();
      alert("Not Valid Inputs");
    }
  };

  const onSubmit = (data) => {
    const res = {
      videoLink: `${data.videoLink}`,
      title: `${data.title}`,
      genre: `${data.genre}`,
      contentRating: `${data.contentRating}`,
      releaseDate: `${data.releaseDate}`,
      previewImage: `${data.previewImage}`,
    };
    postVideoAPI(res);

    console.log(res);
  };

  if (!open) return null;

  return ReactDom.createPortal(
    <div className="overlay">
      <div className="modal">
        <div className="header-name">
          <h2>Upload Video</h2>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          {content.inputs.map((input, key) => {
            return (
              <div key={input.id} className="div-inputs">
                <p>
                  <label>{input.label}</label>
                </p>
                <p>
                  <input
                    className="input"
                    name={input.name}
                    type="text"
                    {...register(`${input.name}`, { required: true })}
                  />
                </p>
                <p>{input.message}</p>
              </div>
            );
          })}
          <div className="select">
            <label>Genre</label>
            <select {...register("genre")}>
              <option value="Education">Education</option>
              <option value="Sports">Sports</option>
              <option value="Comedy">Comedy</option>
              <option value="LifeStyle">LifeStyle</option>
            </select>
          </div>

          <div className="select">
            <label>ContentRating</label>
            {/* ages select options */}
            <select {...register("contentRating")}>
              <option value="7+">7+</option>
              <option value="12+">12+</option>
              <option value="16+">16+</option>
              <option value="18+">18+</option>
            </select>
          </div>

          <div className="select">
            {/* date */}
            <label>Release Date</label>
            <input
              type="date"
              name="releaseDate"
              {...register("releaseDate")}
            />
          </div>

          <button
            id="upload-btn-cancel"
            className="upload-btn btn"
            onClick={onClose}
          >
            Close
          </button>
          <button
            id="upload-btn-submit"
            className="upload-btn btn"
            type="submit"
          >
            Submit Video
          </button>
        </form>
      </div>
    </div>,
    document.getElementById("portal")
  );
}

export default Modal;
